export function getTitleRequirements({ title } = {}) {
  return `Keep in mind that the title of the blog post is: ${title}.`;
}

export function getDescriptionRequirements({ title, summary } = {}) {
  return `Keep in mind that:\n1.The title of the blog post is: ${title}.\n2.The summary of the blog post is: ${summary}.`;
}
